module.exports = __webpack_public_path__ + "static/media/nearbybazar_logo_purple.f7eb55b8.jpg";